export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://rs-baas-cr-dev-969849849056.us-east5.run.app';
export const CHAT_URL = process.env.REACT_APP_CHAT_URL || 'http://localhost:9000/chat';

export const AGENT_MAPPING = {
  chat: "chat_assistant",
  rules: "rule_assistant"
};
